import { useSvgIdPrefix } from "./useSvgIdPrefix"

import type { SVGProps } from "react"

export const AsanaLogoSVG = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = `${useSvgIdPrefix()}-asana-gradient`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="6.353 6.353 54 54"
      fill="none"
      data-testid="asana-logo"
      {...props}
    >
      <path
        d="M48.6095 34.8474C42.1226 34.8474 36.8649 40.2011 36.8649 46.8052C36.8649 53.4099 42.1226 58.7647 48.6095 58.7647C55.0953 58.7647 60.353 53.4099 60.353 46.8052C60.353 40.2011 55.0953 34.8474 48.6095 34.8474ZM18.0971 34.848C11.6113 34.8486 6.35303 40.2011 6.35303 46.8058C6.35303 53.4099 11.6113 58.7641 18.0971 58.7641C24.5834 58.7641 29.8417 53.4099 29.8417 46.8058C29.8417 40.201 24.5834 34.848 18.0965 34.848H18.0971ZM45.0971 19.8995C45.0971 26.5036 39.8394 31.859 33.3536 31.859C26.8667 31.859 21.609 26.5036 21.609 19.8995C21.609 13.2953 26.8667 7.94116 33.3536 7.94116C39.8394 7.94116 45.0966 13.2953 45.0966 19.8995H45.0971Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <radialGradient
          id={gradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.3603 35.749) scale(35.802 33.696)"
        >
          <stop stopColor="#FFB900" />
          <stop offset="0.6" stopColor="#F95D8F" />
          <stop offset="0.999" stopColor="#F95353" />
        </radialGradient>
      </defs>
    </svg>
  )
}
